<template>
  <div>
    <span class="logo"><img src="../assets/logo_jiaxiao.png"> </span>
    <el-tag style="background-color:rgba(0,0,0,0);color:#FFF;border-style:inherit">{{ userInfo.realName }}</el-tag>
    <el-link @click="openResetPasswordDialog()"><el-tag type="info" effect="dark">重置密码</el-tag></el-link>
    <el-link @click="log_out"><el-tag type="info" effect="dark">退出</el-tag></el-link>
    <!-- 重置密码 -->
    <el-dialog
      title="重置密码"
      :visible.sync="resetPasswordDialogVisible"
      width="360px"
      :before-close="handleClose"
      style="text-align:initial">
      <el-form ref="resetPasswordForm" :model="resetPasswordData" :rules="rules" label-width="100px">
        <el-form-item label="请输入密码" :required="true" prop="password">
          <el-input v-model="resetPasswordData.password" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="请再次输入" :required="true" prop="confirmPassword">
          <el-input v-model="resetPasswordData.confirmPassword" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="resetPassword">重置</el-button>
          <el-button @click="resetPasswordDialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default ({
  data () {
    return {
      userInfo: {},
      resetPasswordData: {},
      rules: {
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        confirmPassword: [{ required: true, message: '请确认密码', trigger: 'blur' }]
      },
      resetPasswordDialogVisible: false
    }
  },
  mounted () {
    // console.log(this.Cookie.get('userInfo'))
    if (this.Cookie.get('userInfo') === undefined || this.Cookie.get('userInfo') === '') {
      this.$router.push('/login')
    } else {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
    }
  },
  methods: {
    log_out () {
      this.Cookie.set('userInfo', '')
      this.$router.push('/login')
    },
    handleClose (done) {
      done()
    },
    openResetPasswordDialog () {
      this.resetPasswordData.userId = this.userInfo.id
      this.resetPasswordDialogVisible = true
    },
    resetPassword () {
      let _this = this
      this.$refs['resetPasswordForm'].validate((valid) => {
        if (valid) {
          if (_this.resetPasswordData.password !== _this.resetPasswordData.confirmPassword) {
            this.$message.error('两次输入的密码不一致')
            return
          }
          this.$confirm('确认要重置密码吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.post(this.GLOBAL.host + '/user/resetPassword',
              this.$qs.stringify({
                userId: _this.resetPasswordData.userId,
                password: _this.resetPasswordData.password
              })
            ).then(res => {
              if (res.data != null) {
                if (res.data.status === 200) {
                  this.resetPasswordDialogVisible = false
                  this.$refs['resetPasswordForm'].resetFields()
                  this.$message({
                    type: 'success',
                    message: '操作成功!'
                  })
                }
              }
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
})
</script>

<style>
.top {
  width: 100%;
  height: 100px;
}
.logo {
  width: 100px;
  height: 100px;
  float: left;
}
.logo img {
  max-width: 100%;
}
.log_out_box {
  width: 100px;
  float: right;
  text-align: right;
}
.el-aside {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue